// account-ui catalog — locale it (register: tu, informal).
import en from './en';

const it: typeof en = {
  common: {
    loading: 'Caricamento…',
  },
  account: {
    brand: 'lumi HR',
    home: {
      title: 'Il tuo account lumi HR',
      intro:
        'Questa pagina è tua, non di uno spazio di lavoro. Resta raggiungibile anche quando uno spazio di lavoro a cui appartieni è bloccato o è stato chiuso.',
      rightsTitle: 'Cosa puoi fare qui',
      rights: {
        takeout: 'Scaricare una copia dei tuoi dati non appena è pronta per te.',
        erasure:
          'Chiedere la cancellazione di uno spazio di lavoro e dei suoi dati, o ritirare una richiesta che hai presentato tu.',
        invoices: 'Vedere e scaricare le fatture di uno spazio di lavoro che amministri.',
        export:
          'Esportare uno spazio di lavoro di cui sei proprietario: tutti i suoi dati in un unico archivio cifrato.',
      },
      signInHint:
        'Per tutto questo devi prima accedere. Il link che ti inviamo per e-mail porta solo a questa pagina: non ti fa mai accedere.',
      workspaceHint:
        'Tutto il resto – il tuo lavoro quotidiano e le tue impostazioni – resta nel tuo spazio di lavoro.',
    },
    signIn: {
      title: 'Accedi',
      intro:
        'Usa il tuo indirizzo e-mail lumi HR e la tua password. Non devi indicare uno spazio di lavoro: ti mostriamo quelli a cui appartieni.',
      email: 'Indirizzo e-mail',
      password: 'Password',
      submit: 'Accedi',
      failed: 'Non siamo riusciti a farti accedere con questo indirizzo e-mail e questa password.',
      passkey: 'Accedi con una passkey',
      passkeyHint:
        'Nessun indirizzo e-mail? Un account creato con un numero di cellulare accede con la sua passkey.',
      passkeyFailed: 'Non siamo riusciti a farti accedere con questa passkey.',
      operatorSecondFactor: 'Questo è un account di amministratore di sistema, che richiede un secondo fattore. Qui accedi con una passkey; con password e codice di autenticazione accedi alla console lumi.',
    },
    session: {
      signedInAs: 'Hai effettuato l’accesso come {email}.',
      signOut: 'Esci',
    },
    workspaces: {
      title: 'I tuoi spazi di lavoro',
      intro:
        'Gli spazi di lavoro a cui appartieni. Uno spazio bloccato resta in questo elenco: è esattamente lo scopo di questa pagina.',
      emptyTitle: 'Nessuno spazio di lavoro',
      emptyBody:
        'Questo account non appartiene a nessuno spazio di lavoro. Se te ne aspettavi uno qui, chiedi alla persona che ti ha invitato.',
      loadFailed: 'Non siamo riusciti a caricare i tuoi spazi di lavoro.',
      ssoRequired:
        'Questo spazio di lavoro richiede il single sign-on aziendale. Accedi dallo spazio di lavoro stesso per usare questi strumenti: qui una password non lo apre.',
      state: {
        active: 'Attivo',
        suspended: 'Bloccato',
        provisioning: 'In configurazione',
        erased: 'Cancellato',
        unavailable: 'Non disponibile',
      },
      hint: {
        active: 'Questo spazio di lavoro funziona normalmente.',
        suspended: 'Questo spazio di lavoro è bloccato. Puoi comunque esercitare qui i tuoi diritti.',
        provisioning: 'Questo spazio di lavoro è ancora in fase di configurazione.',
        erased:
          'Questo spazio di lavoro e i suoi dati sono stati cancellati. Restano solo le fatture, perché siamo tenuti a conservarle.',
        unavailable: 'Questo spazio di lavoro al momento non è raggiungibile.',
      },
    },
    invoices: {
      open: 'Mostra le fatture',
      hide: 'Nascondi le fatture',
      empty: 'Per questo spazio di lavoro non ci sono fatture.',
      loadFailed: 'Non siamo riusciti a caricare le fatture di questo spazio di lavoro.',
      download: 'Scarica il PDF',
      documentMissing: 'Per questa fattura non c’è alcun documento da scaricare.',
      documentUnavailable:
        'Il documento della fattura non si riesce a recuperare in questo momento. Esiste ancora: riprova tra poco.',
      downloadFailed: 'Non siamo riusciti a scaricare questa fattura.',
    },
    takeout: {
      title: 'La copia dei tuoi dati',
      what:
        'Questa è una copia dei dati personali che questo spazio di lavoro conserva su di te, insieme a una spiegazione di come vengono utilizzati.',
      availableUntil:
        'Puoi scaricarla fino al {date}. Dopo viene eliminata automaticamente: salvala prima di quella data se vuoi conservarla.',
      download: 'Scarica i miei dati',
      none: 'Qui non c’è nessuna copia dei tuoi dati che ti aspetta.',
      expired:
        'La copia preparata per te si poteva scaricare fino al {date}. Nel frattempo è stata eliminata, come ti avevamo detto.',
      howToAsk:
        'Puoi chiedere una copia in qualsiasi momento: rivolgiti allo spazio di lavoro che conserva i tuoi dati. Appena è pronta ti mandiamo un’email e la scarichi da questa pagina.',
      loadFailed: 'Non siamo riusciti a verificare se c’è una copia dei tuoi dati che ti aspetta.',
      downloadUnavailable:
        'La tua copia non è recuperabile in questo momento. Esiste ancora: riprova tra poco.',
      downloadFailed: 'Non siamo riusciti a scaricare la copia dei tuoi dati.',
    },
    export: {
      title: 'Esporta questo spazio di lavoro',
      intro:
        'Scarica tutto ciò che si trova in questo spazio di lavoro in un unico archivio cifrato. Funziona anche mentre lo spazio è bloccato: è esattamente lo scopo di questa pagina.',
      contents:
        'L’archivio contiene la scheda di ogni persona, ogni file caricato nello spazio di lavoro e i suoi collegamenti ad altri servizi. Trattalo come lo spazio di lavoro stesso: conservalo in un luogo sicuro e non consegnarlo a nessuno che non debba vedere tutto. L’archivio contiene anche, per Personale, Recruiting e Tempo, un documento HR Open Standards (HR-JSON): il formato condiviso per portare i tuoi dati a un altro fornitore.',
      passphraseWarning:
        'La passphrase la scegli tu e noi non la conserviamo mai. Senza di essa l’archivio non si può più aprire, né da te né da noi.',
      passphraseLabel: 'Passphrase per l’archivio',
      passphraseHint: 'Almeno {min} caratteri.',
      confirmLabel: 'Ripeti la passphrase',
      submit: 'Avvia l’esportazione',
      started:
        'L’esportazione è iniziata. La preparazione richiede un po’ di tempo: torna su questa pagina e aggiorna l’elenco.',
      errorTooShort: 'Scegli una passphrase di almeno {min} caratteri.',
      errorMismatch: 'Le due passphrase non coincidono. Controllale e riprova.',
      errorCannotStart:
        'L’esportazione non può iniziare in questo momento: potrebbe essere già in corso un’esportazione di questo spazio di lavoro, oppure lo spazio di lavoro potrebbe essere in fase di chiusura.',
      errorTooMany:
        'Questo spazio di lavoro ha avviato oggi tutte le esportazioni consentite. Riprova domani.',
      errorGeneric:
        'Non siamo riusciti ad avviare l’esportazione. Non è stato modificato nulla: riprova tra poco.',
      listTitle: 'Esportazioni di questo spazio di lavoro',
      refresh: 'Aggiorna',
      loadFailed: 'Non siamo riusciti a caricare le esportazioni di questo spazio di lavoro.',
      empty: 'Di questo spazio di lavoro non è ancora stata fatta nessuna esportazione.',
      startedAt: 'Avviata il {date}',
      availableUntil: 'Scaricabile fino al {date}',
      download: 'Scarica l’archivio',
      downloadGone: 'Questo archivio non è più disponibile. Avvia una nuova esportazione per ottenerne uno.',
      downloadUnavailable:
        'L’archivio non è recuperabile in questo momento. Esiste ancora: riprova tra poco.',
      downloadFailed: 'Non siamo riusciti a scaricare l’archivio.',
      status: {
        requested: 'In coda',
        exporting: 'In preparazione',
        exported: 'Pronta da scaricare',
        failed: 'Non riuscita',
        expired: 'Eliminata',
        unknown: 'Stato sconosciuto',
      },
    },
    erasure: {
      file: 'Richiedi la cancellazione di questo spazio di lavoro',
      loadFailed:
        'Non siamo riusciti a verificare se è stata richiesta la cancellazione di questo spazio di lavoro.',
      confirmTitle: 'Richiedere la cancellazione di questo spazio di lavoro?',
      confirmWhatGoes:
        'Tutto ciò che si trova in «{workspace}» verrebbe cancellato definitivamente: ogni fascicolo del personale, ogni candidatura, ogni documento, ogni registrazione delle ore e ogni impostazione, per tutte le persone che ci lavorano. Dopo non sarà più possibile recuperare nulla.',
      confirmProcess:
        'Stai presentando una richiesta, non viene ancora cancellato nulla. La esaminiamo e, una volta approvata, inizia un periodo di attesa. Puoi ritirare la richiesta in qualsiasi momento finché la cancellazione non è davvero iniziata.',
      invoicesKept: 'Le fatture restano, perché la legge ci obbliga a conservarle.',
      reason: 'Motivo (facoltativo)',
      keep: 'No, mantieni questo spazio di lavoro',
      confirmSubmit: 'Sì, richiedi la cancellazione',
      pendingReview:
        'È stata richiesta la cancellazione di questo spazio di lavoro. Stiamo esaminando la richiesta.',
      pendingUntil:
        'È stata richiesta la cancellazione di questo spazio di lavoro. Verrà cancellato dopo il {date}.',
      paymentsPending:
        'Questo spazio di lavoro è programmato per la cancellazione perché l’account non è stato pagato.',
      paymentsPendingUntil:
        'Questo spazio di lavoro è programmato per la cancellazione perché l’account non è stato pagato. Verrà cancellato dopo il {date}.',
      paymentsSettle:
        'Pagare la fattura in sospeso ferma questa cancellazione. Puoi anche richiedere tu stesso la cancellazione: in tal caso proseguirà a prescindere dal pagamento.',
      paymentsCannotWithdraw:
        'Questa cancellazione è stata programmata perché l’account non è stato pagato, quindi qui non può essere ritirata. Paga la fattura in sospeso per fermarla.',
      confirmTakeover:
        'Questo spazio di lavoro è già programmato per la cancellazione perché l’account non è stato pagato. La tua richiesta subentra a quella cancellazione: pagare la fattura non la fermerà più.',
      withdraw: 'Ritira la richiesta di cancellazione',
      withdrawTitle: 'Ritirare la richiesta di cancellazione?',
      withdrawBody:
        'Questo spazio di lavoro e tutti i suoi dati vengono mantenuti. Puoi richiedere di nuovo la cancellazione in qualsiasi momento.',
      confirmType: 'Digita il nome dello spazio di lavoro ({name}) per confermare',
      confirmMismatch:
        'Il nome digitato non corrisponde a questo spazio di lavoro. Controllalo e riprova.',
      tooLate: 'La cancellazione è iniziata e non può più essere ritirata.',
      conflict: 'Questo spazio di lavoro è già in fase di cancellazione, quindi non è cambiato nulla.',
      nothingOpen: 'Non c’è nessuna richiesta di cancellazione da ritirare per questo spazio di lavoro.',
      filed: 'La tua richiesta di cancellazione è stata inviata. La esamineremo.',
      withdrawn: 'La richiesta di cancellazione è stata ritirata. Questo spazio di lavoro resta.',
    },
    closure: {
      title: 'Chiusura del tuo account lumi',
      intro:
        'Qui si tratta del tuo account lumi vero e proprio — il tuo accesso — e non di uno degli spazi di lavoro qui sopra.',
      open: 'Chiudi il mio account',
      confirmTitle: 'Chiudere il tuo account lumi?',
      whatGoes:
        'Il tuo accesso scompare: questo indirizzo e-mail e questa password smettono di funzionare, un eventuale accesso aziendale collegato viene scollegato e lasci ogni spazio di lavoro a cui appartieni. Scompare anche quello che hai fatto tu in lumi: cancelliamo le tue conversazioni con l’assistente, le notifiche che ti abbiamo inviato e le tue impostazioni per riceverle, e togliamo il tuo nome e i tuoi testi dalle richieste di assistenza e dai messaggi che ci hai scritto.',
      whatStays:
        'I tuoi dati presso ciascun datore di lavoro restano presso quel datore di lavoro. lumi gestisce i sistemi, ma ogni azienda resta responsabile dei propri dati del personale e di candidatura, e chiudere l’account qui non li cancella. Se uno spazio di lavoro è coinvolto in un procedimento giudiziario o in un’indagine ufficiale, dobbiamo conservare ciò che vi è collegato: le tue richieste, i tuoi messaggi e le tue conversazioni di quello spazio restano finché non è concluso.',
      howToErase:
        'Se vuoi che i dati conservati da un datore di lavoro vengano cancellati, rivolgiti direttamente a quell’azienda. È l’azienda a rispondere a questa richiesta, e una parte dei dati è tenuta per legge a conservarla ancora per un certo periodo.',
      noUndo:
        'La chiusura non può essere annullata e non teniamo nulla in sospeso per te. Puoi registrarti di nuovo in qualsiasi momento con lo stesso indirizzo e-mail: sarà un account nuovo e vuoto.',
      confirmType: 'Digita il tuo indirizzo e-mail ({email}) per confermare',
      confirmMismatch: 'Questo non è l’indirizzo e-mail di questo account. Controllalo e riprova.',
      keep: 'No, mantieni il mio account',
      confirmSubmit: 'Sì, chiudi il mio account',
      doneTitle: 'Il tuo account è chiuso',
      doneBody:
        'La sessione è terminata e con questo indirizzo e-mail e questa password non è più possibile accedere da nessuna parte in lumi. Le tue conversazioni con l’assistente e le notifiche che ti abbiamo inviato sono cancellate, e le richieste di assistenza e i messaggi che ci hai scritto non riportano più il tuo nome né i tuoi testi.',
      doneStays:
        'I tuoi dati presso ciascun datore di lavoro restano presso quel datore di lavoro e continuano a essere gestiti da lui. Per la loro cancellazione rivolgiti direttamente a ciascuna azienda. E se uno spazio di lavoro è coinvolto in un procedimento giudiziario o in un’indagine ufficiale, ciò che vi è collegato resta presso di noi finché non è concluso.',
      doneMailed: 'Ti abbiamo inviato una conferma per e-mail.',
      doneNotMailed:
        'Non siamo riusciti a inviarti l’e-mail di conferma. Il tuo account è comunque chiuso.',
      blockedTitle: 'Questi spazi di lavoro hanno ancora bisogno di un proprietario',
      blockedBody:
        'Sei l’unico proprietario degli spazi di lavoro elencati sotto, quindi non possiamo ancora chiudere il tuo account. Uno spazio senza proprietario possiamo riaprirlo solo noi, e tutte le persone che ci lavorano resterebbero tagliate fuori dai propri dati.',
      blockedTransfer:
        'Cedi «{name}»: apri quello spazio di lavoro e trasferisci lì la proprietà a un altro membro.',
      blockedErasure:
        'Oppure richiedi la cancellazione di «{name}» nell’elenco dei tuoi spazi di lavoro qui sopra.',
      blockedReturn:
        'Questo tentativo non viene conservato. Quando nessuno spazio di lavoro avrà più bisogno di te come proprietario, torna su questa pagina e chiudi allora il tuo account.',
      unavailable:
        'La chiusura degli account non funziona in questo momento. Non è stato modificato nulla: riprova tra un momento.',
      alreadyClosed: 'Questo account è già chiuso.',
      failed: 'Non ha funzionato. Il tuo account non è stato chiuso: riprova tra un momento.',
      confirmTypePhone: 'Digita il tuo numero di cellulare completo ({phone}) per confermare',
      confirmMismatchPhone:
        'Questo non è il numero di cellulare di questo account. Controllalo e riprova.',
      whatGoesPhone:
        'Il tuo accesso scompare: le tue passkey e questo numero di cellulare smettono di funzionare, un eventuale accesso aziendale collegato viene scollegato e lasci ogni spazio di lavoro a cui appartieni. Scompare anche quello che hai fatto tu in lumi: cancelliamo le tue conversazioni con l’assistente, le notifiche che ti abbiamo inviato e le tue impostazioni per riceverle, e togliamo il tuo nome e i tuoi testi dalle richieste di assistenza e dai messaggi che ci hai scritto.',
      noUndoPhone:
        'La chiusura non può essere annullata e non teniamo nulla in sospeso per te. Uno spazio di lavoro può invitarti di nuovo con lo stesso numero: sarà un account nuovo e vuoto.',
      doneBodyPhone:
        'La sessione è terminata e con le tue passkey e questo numero di cellulare non è più possibile accedere da nessuna parte in lumi. Le tue conversazioni con l’assistente e le notifiche che ti abbiamo inviato sono cancellate, e le richieste di assistenza e i messaggi che ci hai scritto non riportano più il tuo nome né i tuoi testi.',
      doneScreenOnly: 'Questa schermata è la tua conferma: non ne inviamo una via SMS.',
    },
  },
};

export default it;
